(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations-v2"] && !Shopify.designMode) return;
  try {
    
  function pr2LoadSection(section) {
    if (!section || !section.dataset.url) { return; }
    var request = new XMLHttpRequest();
    request.open("GET", section.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var tmp = document.createElement("div");
        tmp.innerHTML = request.response;
        var fresh = tmp.querySelector('.product-recommendations-v2[data-section-id="' + section.dataset.sectionId + '"]')
          || tmp.querySelector('.product-recommendations-v2');
        if (fresh) {
          section.innerHTML = fresh.innerHTML;

          // Init Swiper carousel when more than 4 products are shown
          var sw = section.querySelector('.pr2-swiper');
          if (sw && typeof Swiper !== 'undefined') {
            new Swiper(sw, {
              slidesPerView: 2,
              spaceBetween: 24,
              loop: sw.dataset.loop === 'true',
              pagination: sw.querySelector('.swiper-pagination')
                ? { el: sw.querySelector('.swiper-pagination'), clickable: true }
                : false,
              navigation: {
                nextEl: sw.querySelector('.swiper-button-next'),
                prevEl: sw.querySelector('.swiper-button-prev')
              },
              breakpoints: {
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 }
              }
            });
          }

          // Re-init Shopify Product Reviews badges after AJAX injection
          try {
            if (window.SPR) {
              if (typeof SPR.initDomEls === 'function') { SPR.initDomEls(); }
              if (typeof SPR.loadBadges === 'function') { SPR.loadBadges(); }
            }
          } catch (e) {}
        }
      }
    };
    request.send();
  }

  function pr2LoadAll() {
    document.querySelectorAll('.product-recommendations-v2[data-url]').forEach(pr2LoadSection);
  }

  document.addEventListener("DOMContentLoaded", pr2LoadAll);

  document.addEventListener("shopify:section:load", function (event) {
    var el = document.querySelector('.product-recommendations-v2[data-section-id="' + event.detail.sectionId + '"]');
    pr2LoadSection(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
